/* eslint-disable */
const numeric = `<problem>
  <numericalresponse>
    <responseparam type="tolerance" default="5"/>
    <formulaequationinput/>
  </numericalresponse>
</problem>`

export default numeric;